import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config.js";
import Layout, { Container } from "../components/layout.js";
import {
  FaFilter,
  FaChevronLeft,
  FaChevronRight,
  FaCheck,
} from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getCookie } from "../config/webStorage.js";

const Conducts = () => {
  let token = getCookie("swtoken");
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [note, setNote] = useState("");
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [data, setData] = useState([]);
  const [month, setMonth] = useState("2026-03");

  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);

  const [limit, setLimit] = useState(100);

  const [pagination, setPagination] = useState({});
  const fetchConducts = async () => {
    try {
      const res = await axios.get(
        `${apiurl}/api/employee/conduct/getByPayrollMonth/${month}?page=${page}&limit=${limit}&status=${status}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      );

      setData(res.data.data);
      setPagination(res.data.pagination);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchConducts();
  }, [page, limit, status, month]);

  const toggleSelect = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((i) => i !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelected([]);
    } else {
      setSelected(data.map((d) => d._id));
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    if (selected.length === data.length && data.length > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selected, data]);

  const downloadExcel = (rows) => {
    const excelData = rows.map((r) => ({
      Employee: r.employeeCode,
      Title: r.title,
      Severity: r.severity,
      Deduction: r.deductionAmount,
      Status: r.deductionStatus,
      Date: new Date(r.createdAt).toLocaleDateString(),
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Conduct Payroll");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([buffer], { type: "application/octet-stream" });

    saveAs(blob, `conduct-payroll-${month}.xlsx`);
  };

  const processConducts = async () => {
    try {
      const res = await axios.post(
        `${apiurl}/api/employee/conduct/mark-processed`,
        {
          conductObjIds: selected,
          note,
        },
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      );

      if (res.data.success) {
        const processedRows = data.filter((d) => selected.includes(d._id));

        // downloadExcel(processedRows);

        setSelected([]);
        setShowProcessModal(false);

        fetchConducts();
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6">
          {/* HEADER */}
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-semibold">Conduct Payroll</h1>

            <div className="flex items-center gap-3">
              <input
                type="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="border rounded-lg px-3 py-2"
              />

              <select
                className="border rounded-lg px-3 py-2"
                value={status}
                onChange={(e) => {
                  setPage(1);
                  setStatus(e.target.value);
                }}
              >
                <option value="">All Status</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="processed">Processed</option>
              </select>
              <button
                disabled={selected.length === 0}
                onClick={() => setShowProcessModal(true)}
                className="bg-green-600 text-white px-4 py-2 rounded-lg disabled:opacity-40 flex items-center gap-2"
              >
                <FaCheck />
                Process Selected ({selected.length})
              </button>

              <button
                disabled={selected.length === 0}
                onClick={() =>
                  downloadExcel(data.filter((d) => selected.includes(d._id)))
                }
                className="bg-blue-600 text-white px-4 py-2 rounded-lg disabled:opacity-40 flex items-center gap-2"
              >
                <FaFilter />
                Download Selected ({selected.length})
              </button>
            </div>
          </div>

                    {/* PAGINATION */}

          <div className="flex items-center justify-between mt-6">
            {/* PER PAGE */}

            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Items per page</span>

              <select
                className="border rounded px-2 py-1"
                value={limit}
                onChange={(e) => {
                  setPage(1);
                  setLimit(e.target.value);
                }}
              >
                <option value={100}>100</option>

                <option value={200}>200</option>

                <option value={500}>500</option>

                <option value={1000}>1000</option>

                <option value={5000}>5000</option>
              </select>
            </div>

            {/* PAGE BUTTONS */}

            <div className="flex items-center gap-3">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="px-3 py-2 border rounded-lg disabled:opacity-40"
              >
                <FaChevronLeft />
              </button>

              <span className="text-sm">
                Page {pagination.currentPage} of {pagination.totalPages}
              </span>

              <button
                disabled={page === pagination.totalPages}
                onClick={() => setPage(page + 1)}
                className="px-3 py-2 border rounded-lg disabled:opacity-40"
              >
                <FaChevronRight />
              </button>
            </div>
          </div>

          {/* TABLE */}

          <div className="bg-white shadow rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="p-3">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleSelectAll}
                    />
                  </th>
                  <th className="p-3 text-left">Employee</th>

                  <th className="p-3 text-left">Title</th>

                  <th className="p-3 text-left">Severity</th>

                  <th className="p-3 text-left">Deduction</th>

                  <th className="p-3 text-left">Status</th>

                  <th className="p-3 text-left">Date</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item) => (
                  <tr key={item._id} className="border-t hover:bg-gray-50">
                    <td className="p-3">
                      <input
                        type="checkbox"
                        checked={selected.includes(item._id)}
                        onChange={() => toggleSelect(item._id)}
                      />
                    </td>

                    <td className="p-3">{item.employeeCode}</td>

                    <td className="p-3">{item.title}</td>

                    <td className="p-3 capitalize">{item.severity}</td>

                    <td className="p-3 font-medium text-red-600">
                      ₹{item.deductionAmount}
                    </td>

                    <td className="p-3">
                      <span
                        className={`px-2 py-1 rounded text-xs font-medium
                    ${
                      item.deductionStatus === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : item.deductionStatus === "approved"
                          ? "bg-blue-100 text-blue-700"
                          : "bg-green-100 text-green-700"
                    }`}
                      >
                        {item.deductionStatus}
                      </span>
                    </td>

                    <td className="p-3">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showProcessModal && (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
              <div className="bg-white p-6 rounded-xl w-96">
                <h2 className="text-lg font-semibold mb-3">
                  Process Conduct Deduction
                </h2>

                <textarea
                  placeholder="Enter note..."
                  className="w-full border rounded p-2 mb-4"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowProcessModal(false)}
                    className="px-4 py-2 border rounded"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={processConducts}
                    className="bg-green-600 text-white px-4 py-2 rounded"
                  >
                    Confirm Process
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default Conducts;